import { useLocalBaselineEmissionsState } from "./useLocalBaselineEmissionsState.ts";
import { useLocalUserState } from "./useLocalUserState.ts";
import { useLocalSitesState } from "./useLocalSitesState.ts";
import { useLocalSolutionMapState } from "./useLocalSolutionMapState.ts";
import { useLocalTargetState } from "./useLocalTargetState.ts";
import { useNavigate } from "react-router";
import { trackEvent } from "./analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";

export const useStartOver = () => {
  const [, , removeBaselineEmissions] = useLocalBaselineEmissionsState();
  const [, , removeUser] = useLocalUserState();
  const [, , removeSites] = useLocalSitesState();
  const [, , removeSolutionMap] = useLocalSolutionMapState();
  const [, , removeTarget] = useLocalTargetState();
  const navigate = useNavigate();

  const handleStartOver = () => {
    trackEvent(
      EventCategory.NavigationMenu,
      "Start Over Clicked",
      window.location.href,
    );
    removeBaselineEmissions.removeItem();
    removeUser.removeItem();
    removeSites.removeItem();
    removeSolutionMap.removeItem();
    removeTarget.removeItem();
    navigate("/");
  };

  return {
    handleStartOver,
  };
};
